<template>
  <Box class="SearchResult">
    <div class="resultBody">
      <h5>
        <a
          :href="searchResult.link"
          rel="noreferrer noopener"
          target="_blank">
          <Icon name="open" />
          {{ searchResult.title }}
        </a>
      </h5>
      <div class="hostname">
        {{ hostname }}
      </div>
      <p>
        {{ searchResult.snippet }}
      </p>
      <Empty v-if="hasNoPeekResults">
        {{ $t('empty') }}
      </Empty>
      <template v-if="reviewExternal">
        <ReviewPreview
          :laptop="laptop"
          :reviewExternal="reviewExternal" />
      </template>
    </div>
    <div class="actions">
      <Btn class="success light" @click="addSearchResult">
        <Icon name="plus" />
        {{ $t('add') }}
      </Btn>
      <Btn
        class="inv noBorder"
        :isLoading="isPeeking"
        @click="peek">
        <Icon name="eye" />
        {{ $t('peek') }}
      </Btn>
    </div>
  </Box>
</template>

<script>
import ReviewPreview from './ReviewPreview'
import { actions } from '@utils'
import { getHostname } from '@utils/strings'
import { propOr } from 'rambda'

export default {
  components: {
    ReviewPreview,
  },
  props: {
    laptop: { type: Object, required: true },
    searchResult: { type: Object, required: true },
  },
  data() {
    return {
      hasNoPeekResults: false,
      isPeeking: false,
      reviewExternal: null,
    }
  },
  computed: {
    hostname() {
      if (!this.searchResult.link) return ''

      return getHostname(this.searchResult.link)
    },
  },
  methods: {
    addSearchResult() {
      const reviewExternal = this.reviewExternal || { url: this.searchResult.link }

      this.$emit('add', reviewExternal)
    },
    peek() {
      return this.$wrap(
        async () => {
          this.hasNoPeekResults = false
          this.reviewExternal = null

          const laptopFills = await this
            .FIND_LAPTOP_FILLER({
              id: this.laptop.id,
              reviewsExternal: [{ url: this.searchResult.link }],
            })

          const [laptopFill] = laptopFills

          if (!laptopFill) {
            this.hasNoPeekResults = true
            return
          }

          const { reviewsExternal, ...laptop } = laptopFill

          this.reviewExternal = {
            ...propOr({}, 0, reviewsExternal),
            laptop,
          }
        },
        'isPeeking',
      )
    },
    ...actions('FIND_LAPTOP_FILLER'),
  },
}
</script>

<style lang="scss">
.Box.SearchResult {
  display: grid;
  grid-template-columns: 1fr 10rem;
  padding: $u;

  .resultBody {
    > .hostname {
      color: $success-dark;
      margin-top: $uh;
    }

    > p {
      margin: $uh 0 0;
    }
  }

  > .actions {
    display: flex;
    flex-direction: column;
  }
}
</style>

<i18n>
{
  "en": {
    "add": "Add",
    "empty": "No peek results",
    "open": "Open",
    "peek": "Peek"
  }
}
</i18n>
